
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Roundtripcab() {



    const cardData =
    {
        keyword: 'Round Trip Cab',
        heading: 'Meghana Cab : Round Trip Cab ',
        headingDescription: 'Meghana Cab offers Round Trip Cab services, perfect for travelers looking for a reliable and cost-effective return journey. Whether it is a family outing, business trip, or weekend getaway, our round trip service ensures you travel comfortably both ways with the same trusted driver. Choose from a variety of clean, well-maintained vehicles and enjoy transparent fares, punctual pickups, and 24/7 customer support. Book your Round Trip Cab with Meghana Cab and experience a hassle-free ride from start to finish.',


        top: 'Top Places to Visit in near Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description": "Twin hill stations just ~65 km from Pune, known for their misty mountains, waterfalls, and lush green valleys. Top spots include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla-Bhaja Caves. Perfect for monsoon trips, short hikes, and chikki shopping. 🏞️"
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description": "A favorite weekend getaway about 120 km away, Mahabaleshwar offers fresh strawberries, boating at Venna Lake, and stunning viewpoints like Arthur’s Seat and Elephant’s Head. Panchgani nearby is known for Table Land and old-world charm. 🍓"
  },
  {
    "title": "Lavasa",
    "description": "A planned hill city with Italian-style architecture, lakeside promenade, water activities, and adventure sports. Located ~60 km from Pune, it’s great for families, couples, and photography enthusiasts. 🚤"
  },
  {
    "title": "Alibaug",
    "description": "A coastal town ~140 km from Pune, known for clean beaches like Varsoli and Alibaug Beach, historic forts like Kolaba, and coastal cuisine. Ideal for a relaxing round trip with beach walks and seafood delights. 🏖️"
  },
  {
    "title": "Bhimashankar Jyotirlinga",
    "description": "One of the twelve Jyotirlingas of Lord Shiva, located around 110 km from Pune. The drive passes through dense forest and ghats. Combine it with a visit to the Bhimashankar Wildlife Sanctuary. 🕉️"
  },
  {
    "title": "Nashik (Trimbakeshwar & Vineyards)",
    "description": "About 210 km from Pune, Nashik offers spiritual visits to Trimbakeshwar Temple and wine tasting at Sula Vineyards. A blend of divinity and leisure for a unique round trip. 🍷"
  },
  {
    "title": "Shirdi & Shani Shingnapur",
    "description": "Spiritual seekers often take a round trip to Shirdi (~190 km), the home of Sai Baba, and Shani Shingnapur, known for its temple with no doors. It’s a peaceful journey filled with devotion. 🙏"
  },
  {
    "title": "Satara (Kaas Plateau & Thoseghar Waterfall)",
    "description": "About 115 km from Pune, Satara boasts the Valley of Flowers (Kaas Plateau) during Aug–Oct and the breathtaking Thoseghar Waterfall. Ideal for nature lovers, especially during monsoon. 🌸"
  },
  {
    "title": "Kolad (River Rafting)",
    "description": "A thrilling spot ~110 km away where the Kundalika River offers grade II–III rafting rapids. Adventure lovers can pair it with camping and ziplining. Best visited during monsoon and post-monsoon. 🛶"
  },
  {
    "title": "Jejuri & Narayanpur",
    "description": "Located around 50–60 km from Pune, Jejuri is famous for the Khandoba temple and golden turmeric festivals. Combine with Balaji Mandir at Narayanpur for a devotional day outing. 🌾"
  }
],

"services": [
    {
        "name": "Round Trip Cab Booking Pune",
        "description": "Book round trip cabs from Pune with Meghana Cab for convenient and comfortable return journeys. Ideal for outstation travel, sightseeing, or business visits."
    },
    {
        "name": "Two-Way Cab Hire Pune",
        "description": "Hire two-way cabs in Pune for flexible travel plans. Meghana Cab provides well-maintained vehicles and experienced drivers for smooth round trips."
    },
    {
        "name": "Round Trip Taxi for Outstation Pune",
        "description": "Travel outstation from Pune and back with our round trip taxi service. Enjoy a relaxed journey with Meghana Cab's safe and punctual transportation."
    },
    {
        "name": "Sedan Round Trip Cab Pune",
        "description": "Choose a comfortable and stylish sedan for your Pune round trip journey. Meghana Cab offers clean, air-conditioned cars perfect for small groups and couples."
    },
    {
        "name": "SUV for Round Trip from Pune",
        "description": "Need more space? Meghana Cab’s SUV round trip cabs from Pune are great for families or groups with ample luggage and a comfortable ride."
    },
    {
        "name": "Pune to Shirdi Round Trip Taxi",
        "description": "Visit Shirdi and return in the same cab with Meghana Cab’s round trip taxi service from Pune. Safe, affordable, and hassle-free travel to the holy destination."
    },
    {
        "name": "Family Round Trip Cabs Pune",
        "description": "Travel with your family in safety and comfort with Meghana Cab’s family round trip services from Pune. Spacious vehicles and courteous drivers guaranteed."
    },
    {
        "name": "Business Round Trip Taxi Pune",
        "description": "Plan your corporate or business round trip travel from Pune with Meghana Cab. Professional drivers and punctual service tailored for working professionals."
    },
    {
        "name": "Online Booking Round Trip Cab",
        "description": "Easily book your round trip cab from Pune online with Meghana Cab’s fast and secure booking system. Get instant confirmation and transparent pricing."
    },
    {
        "name": "Affordable Round Trip Fares Pune",
        "description": "Meghana Cab offers pocket-friendly round trip cab fares from Pune. Travel more, pay less – without compromising service or comfort."
    },
    {
        "name": "Pune Airport Round Trip Cab",
        "description": "Book a round trip taxi to or from Pune Airport with Meghana Cab. Ideal for frequent flyers, ensuring timely pickups and drop-offs both ways."
    },
    {
        "name": "Corporate Cab Round Trips Pune",
        "description": "Get dedicated round trip taxi solutions for corporate travel from Pune. Meghana Cab ensures punctuality, billing support, and comfortable executive rides."
    },
    {
        "name": "Chauffeur Round Trip Taxi Pune",
        "description": "Travel round trip with our chauffeur-driven taxis from Pune. Professional, courteous drivers who ensure safety and on-time service throughout your journey."
    },
    {
        "name": "Weekend Round Trip Cabs Pune",
        "description": "Plan weekend getaways from Pune with Meghana Cab’s weekend round trip services. Visit your favorite destinations and return on your schedule."
    },
    {
        "name": "Best Round Trip Offers Pune",
        "description": "Grab the best deals on round trip cab bookings from Pune with Meghana Cab. Exclusive discounts, packages, and seasonal offers available."
    }
],

"tableData": [
    ["Round Trip Cab Booking Pune", "Two-Way Cab Hire Pune"],
    ["Round Trip Taxi for Outstation Pune", "Sedan Round Trip Cab Pune"],
    ["SUV for Round Trip from Pune", "Pune to Shirdi Round Trip Taxi"],
    ["Family Round Trip Cabs Pune", "Business Round Trip Taxi Pune"],
    ["Online Booking Round Trip Cab", "Affordable Round Trip Fares Pune"],
    ["Pune Airport Round Trip Cab", "Corporate Cab Round Trips Pune"],
    ["Chauffeur Round Trip Taxi Pune", "Weekend Round Trip Cabs Pune"],
    ["Best Round Trip Offers Pune", ""],
    ["", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Convenient and Flexible Round Trip Cab Service",
        "WhyChoosedescription": "Meghana Cab offers reliable round trip cab services for all your travel needs. Whether it’s a business meeting, family function, or a weekend getaway, enjoy a hassle-free experience with pickup and return in a single booking."
    },
    {
        "WhyChooseheading": "One Booking, Two-Way Travel",
        "WhyChoosedescription": "With our round trip cab service, you don’t need to worry about separate bookings for your return journey. Reserve your cab once and travel stress-free both ways."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Round Trip Fares",
        "WhyChoosedescription": "We offer budget-friendly round trip cab pricing with no hidden charges. Get transparent fare details upfront and enjoy value-for-money travel with Meghana Cab."
    },
    {
        "WhyChooseheading": "Clean and Comfortable Vehicles",
        "WhyChoosedescription": "Our cabs are clean, well-maintained, and sanitized before every trip. Whether you're traveling short or long distance, enjoy a comfortable and safe ride with modern amenities."
    },
    {
        "WhyChooseheading": "Professional and Friendly Drivers",
        "WhyChoosedescription": "Our experienced drivers ensure a safe, courteous, and enjoyable round trip journey. They are familiar with intercity and local routes to provide a smooth travel experience."
    },
    {
        "WhyChooseheading": "Customizable Travel Plans",
        "WhyChoosedescription": "Need extra waiting time or multiple stops? Meghana Cab offers fully customizable round trip packages to match your schedule and travel preferences."
    },
    {
        "WhyChooseheading": "24/7 Availability for Round Trips",
        "WhyChoosedescription": "We operate round the clock. Whether your return is on the same day or next, our round trip cab service is available 24/7 to suit your itinerary."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Assistance",
        "WhyChoosedescription": "Book your round trip cab easily through our website or app. For help with your itinerary or special requests, our customer support team is always ready to assist you."
    }
]


























    }

const faqData = [
    {
        question: "How can I book a round trip cab with Meghana Cab?",
        answer: "You can book a round trip cab easily through Meghana Cab’s website or by calling us at +91 9075462128."
    },
    {
        question: "What types of vehicles are available for round trip journeys?",
        answer: "We offer a range of vehicles including hatchbacks, sedans, SUVs, and tempo travellers to suit your travel requirements."
    },
    {
        question: "Is the round trip cab service available for both local and outstation routes?",
        answer: "Yes, Meghana Cab provides round trip cab services for both local city tours and long-distance outstation travel."
    },
    {
        question: "Are tolls, parking, and taxes included in the round trip fare?",
        answer: "Toll charges, parking fees, and state taxes are additional and will be clearly mentioned at the time of booking."
    },
    {
        question: "Can I customize the itinerary for my round trip?",
        answer: "Yes, we offer flexible round trip options. You can customize your pickup, drop, and stops as needed."
    },
    {
        question: "Is round trip cab service available 24/7?",
        answer: "Yes, Meghana Cab operates 24/7. You can book a round trip cab at any time of the day or night."
    },
    {
        question: "Do your drivers have experience with round trip journeys?",
        answer: "Absolutely! All our drivers are experienced in long-distance and round trip travel, ensuring a safe and comfortable journey."
    },
    {
        question: "How do I make payment for round trip bookings?",
        answer: "We accept UPI, debit/credit cards, net banking, and cash for your convenience."
    },
    {
        question: "Can I change my return time during the trip?",
        answer: "Yes, you can request a change in return time by contacting our support team. Charges may vary depending on timing."
    },
    {
        question: "How do I contact Meghana Cab for round trip cab bookings?",
        answer: "You can reach us anytime at +91 9075462128 for round trip cab bookings and inquiries."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Ramesh Nair',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked a round trip cab from Meghana Cab for a weekend getaway. Great service, clean car, and an excellent driver. Highly recommended!”',
    },
    {
        name: 'Mrs. Pallavi Borkar',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Our round trip with Meghana Cab was smooth and hassle-free. Timely pickup and drop, and the ride was very comfortable.”',
    },
];




















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Round Trip Cab",
  "image": "https://www.meghanacabs.com/assets/images/round-trip-cab.jpg",
  "description": "Book round trip cab services in Pune with Meghana Cabs. Affordable sedan and SUV options for family trips, business travel, airport transfers, and weekend getaways.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5287"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/round-trip-cab"
  }
};






    return (
        <div>



<Helmet>
  <title>Round Trip Cab Booking in Pune | Affordable & Reliable | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book round trip cab services in Pune with Meghana Cabs. Affordable sedan and SUV options for family trips, business travel, airport transfers, and weekend getaways." 
  />
  <meta 
    name="keywords" 
    content="Round Trip Cab Booking Pune, Two-Way Cab Hire Pune, Round Trip Taxi for Outstation Pune, Sedan Round Trip Cab Pune, SUV for Round Trip from Pune, Pune to Shirdi Round Trip Taxi, Family Round Trip Cabs Pune, Business Round Trip Taxi Pune, Online Booking Round Trip Cab, Affordable Round Trip Fares Pune, Pune Airport Round Trip Cab, Corporate Cab Round Trips Pune, Chauffeur Round Trip Taxi Pune, Weekend Round Trip Cabs Pune, Best Round Trip Offers Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/14.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Roundtripcab;